"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSchema = void 0;
var tslib_1 = require("tslib");
var SchemaType_1 = require("./SchemaType");
/**
 * Evaluates whether the provided argument is a Schema object
 */
function isSchema(arg) {
    var e_1, _a;
    if (!Boolean(arg) || typeof arg !== 'object') {
        return false;
    }
    try {
        for (var _b = tslib_1.__values(Object.keys(arg)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (!(0, SchemaType_1.isSchemaType)(arg[key])) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
exports.isSchema = isSchema;
